/**
 * Smal rad med de första stegen i anmälan. Visas före formuläret för att
 * visa att fler steg följer och att inget avgörs när man skickar in.
 */
export function StepRow({ steps }: { steps: readonly string[] }) {
  return (
    <div className="mx-auto max-w-6xl px-5 pt-8">
      {/* Mobil: ett steg per rad. Surfplatta och uppåt: en rad med pilar emellan. */}
      <ol className="grid gap-2 text-sm text-muted-foreground sm:flex sm:flex-wrap sm:items-center sm:gap-x-3 sm:gap-y-2">
        {steps.map((label, i) => (
          <li key={label} className="flex items-center gap-3">
            {i > 0 ? (
              <span aria-hidden="true" className="hidden text-border sm:inline">
                →
              </span>
            ) : null}
            <span className="flex items-center gap-2">
              <span className="flex size-5 shrink-0 items-center justify-center rounded-full bg-primary/10 text-xs font-semibold text-primary">
                {i + 1}
              </span>
              <span>{label}</span>
            </span>
          </li>
        ))}
      </ol>
    </div>
  );
}
